import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import useFormGenerator from '../common/FormUtils';
import useHeaderGenerator from '../common/functions/useHeaderGenerator';
import useButtonsGenerator from '../common/functions/useButtonsGenerator';
import { useParams } from 'react-router-dom';
import FormModal from '../common/FormModal';
import ContactService from './ContactService';

import schema from './jsonSchema';
const jsonSchema = schema;
const mergedJsonSchema = jsonSchema => {
  return jsonSchema.map(field => {
    if (field.type === 'group') {
      return {
        ...field,
        fields: field.fields.map(f => assignValueToJsonSchema(f))
      };
    } else {
      return assignValueToJsonSchema(field);
    }
  });
};
const convertInterestsToOptions = interests => {
  const arrayOfInterests = interests.split(',').map(i => i.trim());
  if(interests){
    return arrayOfInterests.map(i => ({ value: i, label: i }));
  }
  return [];
};

const assignValueToJsonSchema = field => {
  const whereValues = [
    { value: 'work', label: 'work' },
    { value: 'family', label: 'family' },
    { value: 'school', label: 'school' },
    { value: 'event', label: 'event' },
    { value: 'club', label: 'club' },
    { value: 'pub', label: 'pub' },
    { value: 'online', label: 'online' },
    { value: 'friend', label: 'friend' },
    { value: 'gym', label: 'gym' },
    { value: 'street', label: 'street' },
    { value: 'coffee', label: 'coffee' },
    { value: 'other', label: 'other' }
  ];
  const whoValues = [
    { value: 'colleague', label: 'colleague' },
    { value: 'family', label: 'family' },
    { value: 'friend', label: 'friend' },
    { value: 'acquaintance', label: 'acquaintance' }
  ];

  if (field.name === 'who') {
    return {
      ...field,
      options: whoValues
    };
  } 
  if (field.name === 'where') {
    return {
      ...field,
      options: whereValues
    };
  }

  return field;
};
const ContactForm = () => {
  const { identifier } = useParams();
  const [data, setData] = useState();
  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    if (undefined !== identifier) {
      ContactService.retrieveContact(identifier)
        .then(data => {
          console.log('Data:', data);
          const updatedData = {
            ...data,
            where: { label: data.where, value: data.where },
            who: { label: data.who, value: data.who },
            interests: convertInterestsToOptions(data.interests)

          };
          console.log('Updated Data:', updatedData);
          setData(updatedData);
        })
        .catch(error => console.log(error));
    }
  }, [identifier]);
  const handleContactFormSubmit = formData => {
    ContactService.saveContact(formData)
      .then(response => {
        console.log(response);
        setModalShow(true);
      })
      .catch(error => console.log(error));
  };

  const buttonsConf = [
    {
      name: 'Save Contact',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Save Contact');
      }
    }
  ];
  const title = identifier ? 'Edit Contact' : 'Create Contact';
  const headerGenerated = useHeaderGenerator(title, ' ', []);

  return (
    <>
      {headerGenerated}
      {modalShow && (
        <FormModal
          message={'Contact  has been updated!'}
          redirectUrl="/app/contacts"
          modalShow={modalShow}
          setModalShow={setModalShow}
        />
      )}
      <Card>
        <Card.Body>
          {data || undefined === identifier ? (
            // Pass data to the form generator hook
            <FormGeneratorWithData
              data={data}
              buttonsConf={buttonsConf}
              onSubmit={handleContactFormSubmit}
            />
          ) : (
            <p>Loading...</p>
          )}
        </Card.Body>
      </Card>
    </>
  );
};
const FormGeneratorWithData = ({ data, buttonsConf, onSubmit }) => {
  const [validated, setValidated] = useState(false);
  const buttonsGenerated = useButtonsGenerator(buttonsConf);
  // Use the useFormGenerator hook with the provided data
  const { formFields, handleSubmit, handleChange } = useFormGenerator(
    mergedJsonSchema(jsonSchema),
    onSubmit,
    data,
    setValidated
  );

  // Render your form using the formFields and event handlers
  return (
    <Form
      className="mb-2"
      noValidate
      validated={validated}
      onSubmit={handleSubmit}
    >
      {formFields}
      <Card.Footer>{buttonsGenerated}</Card.Footer>
    </Form>
  );
};
export default ContactForm;
